import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Checkout from '@/components/Checkout'
import Lunch from '@/components/Lunch'
import Home from '@/components/Home'
import Dark from '@/components/Dark'
import StartPage from '@/components/StartPage'


Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/checkout',
      name: 'checkout',
      component: Checkout
    },
    {
      path: '/lunch',
      name: 'lunch',
      component: Lunch
    },
    {
      path: '/darkscreen',
      name: 'darkscreen',
      component: Dark
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/',
      name: 'startpage',
      component: StartPage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js